export enum UserImportJobStatus {
  UPLOADED = "uploaded",
  VALID = "valid",
  REVIEW = "review",
  COMPLETE = "complete",
}

export enum UserImportJobRecordActionType {
  NEW = "new",
  UPDATES = "updates",
  ARCHIVE = "archive",
  REACTIVATE = "reactivate",
}

export enum UserImportJobFailureType {
  WrongS3Format = "WrongS3Format",
  FailedToGetFile = "FailedToGetFile",
  JobNotFound = "JobNotFound",
  InvalidTemplateStructure = "InvalidTemplateStructure",
  MissingEmail = "MissingEmail",
  UnexpectedError = "UnexpectedError",
  InvalidDataFormat = "InvalidDataFormat",
  MissingRequiredField = "MissingRequiredField",
  InvalidAttributeValue = "InvalidAttributeValue",
}

export enum UserImportJobFailurePhase {
  VALIDATION = "validation",
  REVIEW = "review",
}
export interface UserImportJobTemplateColumn {
  key: string;
  dataType: string;
  isRequired: boolean;
}

export type UserImportJobTemplateRow = Record<string, string>;

export interface GetTemplateResult {
  columns: UserImportJobTemplateColumn[];
  rows?: UserImportJobTemplateRow[];
}

export interface GetTemplateQueryParams {
  isPrefilled?: boolean;
  search?: string;
  page?: number;
  pageSize?: number;
}
export interface UserImportJobTemplateUserRow {
  firstName: string;
  lastName: string;
  status: string;
  roles: string;
  user: { email: string };
  userAttributes: { attributeKey: string; attributeValue: string | null }[];
}
export interface UserImportJobBody {
  UserImportJobUid?: string;
  filePath: string;
  autoFix: boolean;
  status: UserImportJobStatus;
}
export interface CreateUpdateUserImportJobResult {
  UserImportJobUid: string;
}

export type UserImportJobFailureCounts = Partial<
  Record<UserImportJobFailureType, number>
>;
export interface UserImportJobValidateResult {
  job: string;
  errors: UserImportJobFailureCounts;
  warnings: UserImportJobFailureCounts;
}

/** @deprecated use {@link UserImportJobValidateResult} */
export type ValidateTemplateResult = UserImportJobValidateResult;
export interface UserImportJobFailureLogItem {
  FailurePhase: string;
  FailureType: string;
  Message: string;
  Email?: string;
  Name?: string;
}
export interface UserImportJobReviewUserRow {
  UserImportJobRecordUid: string;
  firstName: string;
  lastName: string;
  email: string;
}
export interface UserImportJobReviewSummary {
  new: number;
  archived: number;
  updates: number;
  reactivate: number;
}
export interface UserImportJobReviewQueryParams {
  search?: string;
  actionType?: UserImportJobRecordActionType;
  limit?: number;
  offset?: number;
  orderBy?: string;
  sort?: "asc" | "desc";
}
export interface UserImportJobReviewResult {
  summary: UserImportJobReviewSummary;
  count: number;
  previousPage: string;
  nextPage: string;
  rows: UserImportJobReviewUserRow[];
}
export interface UserImportJobRecordAttributeChange {
  attributeKey: string;
  attributeCurrentValue: string;
  attributeNewValue: string;
}
export interface UserImportJobNewRecordAttributeChange {
  attributeKey: string;
  attributeNewValue: string;
}
export interface UserImportJobRecordResult {
  name: string;
  email: string;
  attributes: UserImportJobRecordAttributeChange[];
}
export interface UserImportJobNewRecords {
  name: string;
  email: string;
  attributes: UserImportJobNewRecordAttributeChange[];
}
export interface UserImportJobDetailResult {
  records: UserImportJobRecordResult | UserImportJobNewRecords;
}
export interface UserImportJobExecuteQueryParams {
  new?: boolean;
  updates?: boolean;
  archive?: boolean;
  reactivate?: boolean;
}
export interface UserImportJobExecuteReason {
  name: string;
  email: string;
  message: string;
}

export interface UserImportJobExecuteActionSummary {
  added: number;
  failed: number;
  reasons: UserImportJobExecuteReason[];
  // Non-empty (e.g. "Disabled - no records processed") when the section was skipped.
  message: string;
}

export interface UserImportJobExecuteSummary {
  new: UserImportJobExecuteActionSummary;
  updates: UserImportJobExecuteActionSummary;
  archived: UserImportJobExecuteActionSummary;
  reactivated: UserImportJobExecuteActionSummary;
}

export interface UserImportJobExecuteResult {
  UserImportJobUid: string;
  status: UserImportJobStatus;
  summary: UserImportJobExecuteSummary;
}
export interface UserImportJobModel {
  UserImportJobId?: number;
  UserImportJobUid: string;
  PortalId: number;
  PortalUid: string;
  filePath?: string;
  autoFix: boolean;
  status: UserImportJobStatus;
  userCreated: string;
  userUpdated: string;
}
export interface UserImportJobRecordsByAction {
  actionType: string;
  count: string;
}
export interface UserImportJobOverviewResult {
  job: UserImportJobModel;
  totalRecords: number;
  recordsByAction: UserImportJobRecordsByAction[];
}
